export class Workstep {
  id: number;
  name: string;
  description: string;
  producttype: number;
  stationsno: number;
  station0: string;
  station1: string;
  station2: string;
  station3: string;
  minutesakilo: number;
  minutesaday: number;
  acronym: string;
  abbreviation: string;
  flip: boolean;
  time_engine_enabled?: boolean;
  time_metric?: string;
  time_scope?: string;
  time_setup_seconds?: number;
  time_load_seconds?: number;
  time_unload_seconds?: number;
  time_rule_version?: number;
  time_segments?: WorkstepTimeSegment[];
  time_adjustments?: WorkstepTimeAdjustment[];
  createdAt: Date;
}
export interface WorkstepTimeSegment {
  id?: number; sequence: number; from_value: number; to_value: number;
  seconds: number; rate_mode?: string; rate_value?: number; active: boolean; notes?: string;
}
export interface WorkstepTimeCondition {
  id?: number; sequence: number; property: string; operator: string;
  from_value: number; to_value?: number; active: boolean;
}
export interface WorkstepTimeAdjustment {
  id?: number; sequence: number; name: string; percent: number; mode?: string; value?: number; active: boolean;
  notes?: string; conditions: WorkstepTimeCondition[];
}
